var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteFritz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.386,
    height: 126.558,
    viewBox: "0 0 92.386 126.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(-106.506 -106.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(106.506 106.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M197.68,320.494l-13.012,6.3-13.01-6.3v17.548l13.01-6.3,13.012,6.3Z",
    transform: "translate(-138.477 -211.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M198.892,156.684h-5.173V136.75c0-5.282-6.437-11.719-11.719-11.719h-.009l.017-.038h-30.72a8.692,8.692,0,0,1-3.261-.759,16.275,16.275,0,0,1-3-2.589,18.572,18.572,0,0,1-2.248-3.113,45.688,45.688,0,0,1-2.043-4.835c-.154-.507-1.727-6.7-1.727-6.7H139a.882.882,0,0,0-1.633,0h0s-.284.871-.676,2.395c-.067.291-.244,1.121-.433,2.116a47.492,47.492,0,0,0-.5,5.125c0,.957.032,1.872.092,2.388.1.837.215,1.62.306,1.98a22.976,22.976,0,0,0,2.006,5.26,25.379,25.379,0,0,0,3.635,4.952c.461.5.986.95,1.5,1.407v.012c-.458-.225-.915-.463-1.355-.728a24.391,24.391,0,0,1-5.216-3.958,21.027,21.027,0,0,1-2.548-2.955H123.388c-5.279,0-11.72,6.437-11.72,11.719v19.972h-5.162V165.3h3.475a20.141,20.141,0,0,0,39.6,3.894h6.237a20.141,20.141,0,0,0,39.6-3.894h3.475Zm-79.527-14.521,4.869,4.922,5.112-9.24h46.69l.009.037,5.112,9.239,4.867-4.92,1.923,14.483H156.024v3.9h-6.648v-3.9h-31.94Zm10.722,34.923a12.983,12.983,0,0,1-12.911-11.79h25.819A12.979,12.979,0,0,1,130.087,177.086Zm45.223,0A12.978,12.978,0,0,1,162.4,165.3h25.82A12.984,12.984,0,0,1,175.31,177.086Z",
    transform: "translate(-106.506 -106.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M218.09,274.863a1.89,1.89,0,0,0-2.139,1.6,9.243,9.243,0,0,1-15.845,5.035,1.887,1.887,0,1,0-2.734,2.6,12.941,12.941,0,0,0,9.1,4.049c.113,0,.227,0,.338,0A13.034,13.034,0,0,0,219.688,277,1.892,1.892,0,0,0,218.09,274.863Z",
    transform: "translate(-150.839 -189.083)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFritz);
export default __webpack_public_path__ + "static/media/whiteFritz.3294d34688098afc26e15cce0cf38920.svg";
export { ForwardRef as ReactComponent };